import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { AgrSharedModule } from '@next/core-lib/shared';
import { SiteState } from '@next/core-lib/site';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';

import * as MowingMonitorActions from '../../store/mowing-monitor.actions';

@Component({
  selector: 'app-monitor-import',
  templateUrl: './monitor-import.component.html',
  styleUrls: ['./monitor-import.component.scss'],
  standalone: true,
  imports: [AgrSharedModule],
})
export class MonitorImportComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  readonly hasAtLeastAdministratorRole = toSignal(
    this.store
      .select(AuthorizationSelectors.hasAtLeastAdministratorRole)
      .pipe(filter((value): value is boolean => value !== undefined && value !== null)),
    { initialValue: false },
  );

  openImportDialog() {
    this.store.dispatch(MowingMonitorActions.importMonitorItems());
  }
}
